export const formatDateBR = (dateString) => {
  if (!dateString) return "A definir"

  if (dateString.includes('T')) {
    const [year, month, day] = dateString.split('T')[0].split('-')
    return `${day}/${month}/${year}`
  }

  const parts = dateString.split('-')
  if (parts.length === 3) {
    if (parts[0].length === 4) return `${parts[2]}/${parts[1]}/${parts[0]}`
    return `${parts[0]}/${parts[1]}/${parts[2]}`
  }

  return dateString
}

export const formatTimeBR = (timeString) => {
  if (!timeString) return "A definir"

  if (timeString.includes('T')) {
    return timeString.split('T')[1].substring(0, 5)
  }

  if (timeString.match(/^\d{2}:\d{2}:\d{2}$/)) {
    return timeString.substring(0, 5)
  }

  return timeString
}
